import { render, staticRenderFns } from "./TotalGradeRange.vue?vue&type=template&id=0463335e&scoped=true"
import script from "./TotalGradeRange.vue?vue&type=script&lang=js"
export * from "./TotalGradeRange.vue?vue&type=script&lang=js"
import style0 from "./TotalGradeRange.vue?vue&type=style&index=0&id=0463335e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463335e",
  null
  
)

export default component.exports